export default __webpack_public_path__ + "static/media/balon.742014b5.png";